<template>

<div class="group" v-if="treatments.length">

	<com-input :input="input" />

</div>

</template>

<script>

import comInput from '@/components/tool/common/section/form/Input'

export default {

	props: ['recommendation'],

	components: {
		'com-input': comInput,
	},

	watch: {

		selected: function(n) {

			if (this.hasNone && n.length > 1) {

				this.$store.commit('session/values/override', {
					id: this.$store.getters['data/setup'].treatments.variable,
					value: [0]
				})

			}

		}

	},

	computed: {

		treatments: function() {

			return this.recommendation.treatments

		},

		selected: function() {

			return this.$store.getters['logic/variable'](this.$store.getters['data/setup'].treatments.variable)

		},

		hasNone: function() {

			return this.$_.contains(this.selected, 0)

		},

		input: function() {

			var treatments = []

			treatments.push({
				id: 0,
				value: 0,
				text: 'No treatment'
			})
			
			this.$_.each(this.treatments, function(treatment) {

				treatments.push({
					id: treatment,
					value: treatment,
					text: this.$store.getters['data/setup'].treatments.options[treatment].name
				})

			}.bind(this))

			return {
				id: 0,
				variable: this.$store.getters['data/setup'].treatments.variable,
				info: 0,
				type: this.$constants.input.type.toggle,
				disabled: (this.hasNone) ? this.treatments : [],
				name: '',
				layout: {
					stacked: 1	
				},
				default: {
					enabled: 0,
					value: 0,
					logic: {}
				},
				required: {
					enabled: this.$constants.required.always,
					logic: {}
				},
				visibility: {
					enabled: this.$constants.required.always,
					logic: {}
				},
				multiple: {
					enabled: 1
				},
				locked: {
					enabled: 0
				},
				automated: {
					enabled: 0
				},
				track: {
					enabled: 0
				},
				text: {
					label: 'Please select which treatment options you would like to discuss with the patient later.'
				},
				options: treatments
			}

		}

	}

}

</script>

<style scoped>

.is-mobile .group {
	padding-top: 16px;
}

</style>